<template>
    <div class="mobile-navigation">
        <div class="mobile-navigation__wrapper">

            <div class="mobile-navigation__header-wrapper">
                <button class="mobile-navigation__close"
                        @click="closeNavigation()">
                    <svg width="20" height="20">
                        <use xmlns:xlink="http://www.w3.org/1999/xlink"
                             xlink:href="#svg-close">
                        </use>
                    </svg>
                </button>
                <button class="mobile-navigation__close-search"
                        v-close-mobile-search>
                    <svg width="44" height="20">
                        <use xmlns:xlink="http://www.w3.org/1999/xlink"
                             xlink:href="#svg-arrow-back-long">
                        </use>
                    </svg>
                </button>
                <div class="mobile-navigation__search-wrapper">
                    <item-search type="mobile"></item-search>
                </div>
            </div>

            <div class="mobile-navigation__content-wrapper">
                <div class="mobile-navigation__tabs-wrapper">
                    <ul id="mobile-tab-menu"
                        class="mobile-navigation__tab-list"
                        role="menu">
                        <li class="mobile-navigation__tab-item"
                            role="menuitem"
                            v-for="category in dataContainer1"
                            v-if="showCategorie(category.id)"
                            v-show="!category.hideCategory"
                            @click="slideTo(category.children, category.id, category)"
                            :class="{'mobile-navigation__tab-item--active': parent.id === category.id}">
                            {{ category.details[0].name }}
                        </li>
                    </ul>
                </div>

                <div class="mobile-navigation__menu-wrapper">
                    <ul id="mobile-menu-list"
                        class="mobile-navigation__menu-list"
                        role="menu">

                        <li class="mobile-navigation__menu-all"
                            role="menuitem"
                            v-if="typeof parent.details !== 'undefined' && typeof parent.details[0] !== 'undefined' && typeof customLinks[parent.id] === 'undefined'">
                            <a class="mobile-navigation__menu-all-link"
                               :href="getCategoryUrl(parent.url)"
                               :title="parent.details[0].name"
                               data-to-all="true"
                               @click="closeNavigation()"
                               :id="'heading-' + parent.id">
                                {{ $translate("ODNaPo::NaPo.toAllCategoriesMobile") }}
                            </a>
                        </li>

                        <li class="mobile-navigation__menu-all"
                            role="menuitem"
                            v-if="typeof parent.details !== 'undefined' && typeof parent.details[0] !== 'undefined' && typeof customLinks[parent.id] !== 'undefined'">
                            <a class="mobile-navigation__menu-all-link"
                               :href="customLinks[parent.id]"
                               :title="parent.details[0].name">
                                {{ $translate("ODNaPo::NaPo.toAllCategoriesMobile") }}
                            </a>
                        </li>

                        <li class="mobile-navigation__menu-item"
                            role="menuitem"
                            v-for="category in dataContainer2"
                            v-show="!category.hideCategory"
                            v-if="category.showChildren || typeof category.details[0] !== 'undefined'">
                            <template v-if="getReplace(category)">
                                <a class="mobile-navigation__menu-link"
                                   :href="getReplace(category).url"
                                   :title="getReplace(category).details[0].name"
                                   @click="closeNavigation()"
                                   :id="'heading-' + getReplace(category).id">
                                    {{ getReplace(category).details[0].name }}
                                </a>
                            </template>
                            <template v-else>
                                <a class="mobile-navigation__menu-link"
                                   :href="getCategoryUrl(category.url)"
                                   :title="category.details[0].name"
                                   @click="closeNavigation()"
                                   :id="'heading-' + category.id">
                                    {{ category.details[0].name }}
                                </a>
                            </template>
                        </li>

                        <template v-if="typeof saleLinks !== 'undefined'">
                            <li class="mobile-navigation__menu-item"
                                role="menuitem"
                                v-if="saleLinks[parent.id] && typeof saleLinks[parent.id] !== 'undefined'">
                                <a class="mobile-navigation__menu-link mobile-navigation__menu-link--sale"
                                   :href="getCategoryUrl(parent.url) + '/sale'"
                                   :title="parent.details[0].name + $translate('ODNaPo::NaPo.headerSale')">
                                    {{ $translate("ODNaPo::NaPo.headerSale") }}
                                </a>
                            </li>
                        </template>

                        <template v-if="typeof newLinks !== 'undefined'">
                            <li class="mobile-navigation__menu-item"
                                role="menuitem"
                                v-if="newLinks[parent.id] && typeof newLinks[parent.id] !== 'undefined'">
                                <a class="mobile-navigation__menu-link mobile-navigation__menu-link--new"
                                   :href="getCategoryUrl(parent.url) + '/new'"
                                   :title="parent.details[0].name + $translate('ODNaPo::NaPo.headerNew')">
                                    {{ $translate("ODNaPo::NaPo.headerNew") }}
                                </a>
                            </li>
                        </template>

                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState } from "vuex";
    import { MediaQueryHelper } from "ceres/app/helper/MediaQueryHelper";
    import { isDefined, isNullOrUndefined } from "ceres/app/helper/utils";

    export default {

        props: {
            initialCategory: {},
            enabledCategories: {},
            saleLinks: {},
            customLinks: {},
            newLinks: {},
            lang: {},
            newLink: {},
            saleLink: {},
            breakpoints: {
                type: Array,
                default: () => ["xs", "sm", "md"]
            },
            includeLanguage: Boolean,
            menuReplace: {}
        },

        data() {
            return {
                dataContainer1: [],
                dataContainer2: [],
                currentCatId: false,
                parent: {},
                isNavigationInitialized: false,
                menuReplaceCategory: null
            };
        },


        computed: {
            ...mapState({
                navigationTree: state => state.navigation.tree
            }),
        },

        created()
        {
            this.addEventListener();

            this.$store.commit("setCurrentCategory", this.initialCategory);
        },

        methods: {

            addEventListener() {

                const QueryHelper = new MediaQueryHelper();
                const breakpoint  = QueryHelper.getCurrentBreakpoint();

                QueryHelper.addFunction(this.loadInitialTree, ["xs", "sm", "md"]);

                if (this.breakpoints.includes(breakpoint)) {
                    this.loadInitialTree();
                }
            },

            loadInitialTree() {

                if (this.navigationTree.length <= 0)
                {
                    const categoryId = null;

                    this.$store.dispatch("loadPartialNavigationTree", categoryId)
                        .then(response =>
                        {
                            this.$store.commit("setNavigationTree", response);
                            this.initNavigation();
                        });
                }
            },

            initNavigation() {

                this.dataContainer1 = this.navigationTree;

                if (this.initialCategory && this.initialCategory.id) {
                    if (this.initialCategory.linklist === "N") {
                        this.$store.commit("setCurrentCategory", this.initialCategory);
                    } else {
                        this.$store.dispatch("setCurrentCategoryById", { categoryId: parseInt(this.initialCategory.id) });
                    }
                }

                this.initialSlide(this.$store.state.navigation.currentCategory);

                this.isNavigationInitialized = true;

            },

            initialSlide(currentCategory) {

                if(!isNullOrUndefined(currentCategory)) {

                    let id = currentCategory.id;

                    //child or root category
                    if(this.enabledCategories.includes(id)) {
                        this.slideTo(currentCategory.children, currentCategory.id, currentCategory);
                    }else if (typeof currentCategory.parent !== 'undefined') {

                        let parent = currentCategory.parent;

                        while (typeof parent.parent !== 'undefined') {
                            parent = parent.parent;
                        }

                        this.slideTo(parent.children, parent.id, parent);
                    }else {
                        this.slideToFirst();
                    }
                }else {
                    this.slideToFirst();
                }
            },

            slideToFirst () {

                for(let i = 0; i < this.navigationTree.length; i++) {
                    if(
                        this.navigationTree[i].children &&
                        typeof this.navigationTree[i].children !== 'undefined' &&
                        this.enabledCategories.includes(this.navigationTree[i].id) &&
                        this.hasDetails(this.navigationTree[i].id)
                    ) {
                        this.slideTo(this.navigationTree[i].children, this.navigationTree[i].id, this.navigationTree[i]);
                        break;
                    }
                }
            },

            slideTo(children, catId, parent) {

                if(catId !== this.currentCatId) {
                    this.parent         = parent;
                    this.currentCatId   = catId;
                    this.dataContainer2 = children;
                }
            },

            closeNavigation() {
                document.querySelector('body').classList.remove('mobile-navigation--visible');
                document.querySelector('.mobile-navigation.mobile-navigation--open').classList.remove('mobile-navigation--open');
            },

            showCategorie(id) {

                return (
                    typeof this.enabledCategories !== 'undefined' &&
                    this.enabledCategories.length > 0 &&
                    this.enabledCategories.includes(id) &&
                    this.hasDetails(id)
                )
            },

            hasDetails(id) {

                for(let key in this.dataContainer1) {
                    if(this.dataContainer1.hasOwnProperty(key)) {

                        let cat = this.dataContainer1[key];

                        if(cat.id == id && cat.details.length > 0) {
                            return true;
                        }

                    }
                }

                return false;

            },

            getCategoryUrl(url) {

                const trailingSlash = url[0] === "/" ? "" : "/";
                const prefix        = this.includeLanguage ? `/${App.language}${trailingSlash}` : "";

                return prefix + url;
            },

            getReplace(category) {

                if(Object.keys(this.menuReplace).length > 0 && !isNullOrUndefined(this.menuReplace[category.id])) {
                    return this.menuReplace[category.id];
                }

                return false;
            }
        }
    }
</script>
